import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=51022dac&scoped=true&"
import script from "./Issues.vue?vue&type=script&lang=js&"
export * from "./Issues.vue?vue&type=script&lang=js&"
import style0 from "./Issues.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Issues.vue?vue&type=style&index=1&id=51022dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51022dac",
  null
  
)

export default component.exports